module.exports = __webpack_public_path__ + "static/media/1.c39fc9e2.jpeg";